import { useField } from 'formik'
import { ContentCount as CountCountType } from 'types'
import React, { FunctionComponent } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useId } from '@react-aria/utils'
import Styles from 'components/FirstTimeExperienceModal/steps/BrandPlanAwareness/ContentCount.module.scss'
import cx from 'classnames'
import { CountInput } from 'components/Wizards/CountInput/CountInput'
import { CountInputProps } from 'components/Wizards/CountInput/Types'
import { Text } from 'blaze-ui/Text/Text'

interface ContentCountProps extends Omit<CountInputProps, 'customPlusButton'> {
  label: FunctionComponent<{ id: string }>
}

export const ContentCount = ({ label: Label, value, name, buttonVariant = 'ghost', ...rest }: ContentCountProps) => {
  const { isMobile } = useResponsiveDesign()
  const id = useId()

  return (
    <div className={Styles.count} role="group" aria-labelledby={id}>
      <div className={cx(Styles.type, { [Styles.empty]: value === 0 })}>
        <Label id={id} />
      </div>
      <CountInput
        buttonVariant={isMobile ? 'ghost-tertiary' : buttonVariant}
        flex
        size="md"
        buttonSize="xs"
        name={name}
        value={value}
        min={0}
        max={15}
        {...rest}
        className={cx(Styles.countInput, { [Styles.empty]: value === 0 })}
      />
    </div>
  )
}

export const ContentCountField = ({ name, label, interval }: { name: string; label: string; interval?: string }) => {
  const [{ value }, , { setValue }] = useField<CountCountType>(name)

  return (
    <ContentCount
      label={({ id }: { id: string }) => (
        <div className={Styles.label}>
          <Text variant="largeList" id={id}>
            {label}
          </Text>
          {interval && <Text variant="placeholder">/ {interval}</Text>}
        </div>
      )}
      value={value.count}
      onChange={(newValue) => setValue({ ...value, count: newValue })}
      name={name}
    />
  )
}
